// --- Helper Functions ---
export const formatCurrency = (value, decimals = 0) => {
    if (value == null || isNaN(value) || !isFinite(value)) return 'N/A';
    const options = { style: 'currency', currency: 'USD', minimumFractionDigits: decimals, maximumFractionDigits: decimals };
    return new Intl.NumberFormat('en-US', options).format(value);
};

export const formatPercentage = (value) => {
    if (value == null || isNaN(value) || !isFinite(value)) return 'N/A';
    return `${(value * 100).toFixed(2)}%`;
};

export const formatYears = (value) => {
    if (value == null || isNaN(value) || !isFinite(value)) return 'N/A';
    return `${value.toFixed(2)} years`;
};

export const formatNumber = (value, decimals = 2) => {
    if (value == null || isNaN(value) || !isFinite(value)) return 'N/A';
    return Number(value).toFixed(decimals);
};

export const formatKWh = (value) => {
    if (value == null || isNaN(value) || !isFinite(value)) return 'N/A';
    return `${value.toLocaleString()} kWh`;
};

export const formatMW = (value) => {
    if (value == null || isNaN(value) || !isFinite(value)) return 'N/A';
    return `${value.toFixed(2)} MW`;
};

export const formatMWh = (value) => {
    if (value == null || isNaN(value) || !isFinite(value)) return 'N/A';
    return `${value.toFixed(2)} MWh`;
};

export const formatLargeNumber = (value) => {
    if (value == null || isNaN(value) || !isFinite(value)) return 'N/A';
    
    if (value >= 1000000000) {
        return `${(value / 1000000000).toFixed(1)}B`;
    } else if (value >= 1000000) {
        return `${(value / 1000000).toFixed(1)}M`;
    } else if (value >= 1000) {
        return `${(value / 1000).toFixed(1)}K`;
    }
    
    return value.toFixed(0);
};